var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"updates-container"},[(_vm.Text)?_c('v-btn',{attrs:{"color":"accent","disabled":!_vm.Updated},on:{"click":_vm.Refresh}},[_c('span',[_vm._v(_vm._s(_vm.Text))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }